// @flow
import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import withLingua from '../withLingua/withLingua';
import {RecommendedDestinationsCarousel} from '@homeaway/react-property-carousel';
import routerActions from '../../actions/router';
import {
    BREAKPOINTS,
    LINGUA_TITLE_KEY,
    SERP_LARGE_SEARCH_TERM_DESTINATION
} from './constants';
import './DestinationCarousel.less';

import type {LinguaProps} from '../withLingua/withLingua';
import type {IntlShape} from 'react-intl';
import type {TypeaheadSuggestion} from '../../queries/searchRequestQuery';
import type {State as ReduxState} from '../../reducers';

type OwnProps = {
    isLoading: boolean,
    carouselData: any,
    intl: IntlShape,
    locationSearch: typeof routerActions.search,
    typeaheadSuggestion: TypeaheadSuggestion
};

type StateProps = {
    isBoundingBoxSearch?: boolean
};

type Props = OwnProps & StateProps & LinguaProps;

export class DestinationCarousel extends PureComponent<Props> {
    handleOnClick = (
        evt: SyntheticEvent<HTMLInputElement>,
        position: number
    ) => {
        const {
            locationSearch,
            carouselData: {recommendedDestinations}
        } = this.props;
        let q = '';
        const index = position - 1;
        if (
            recommendedDestinations.length &&
            recommendedDestinations[index].place &&
            recommendedDestinations[index].place.name.full
        ) {
            q = recommendedDestinations[index].place.name.full;
            locationSearch({q});
        }
    };

    getPropertyWithImages = (arr: any) => arr.filter((item) => item.imageHref);

    render() {
        const {
            isLoading,
            isBoundingBoxSearch,
            messages,
            typeaheadSuggestion: {name},
            intl,
            carouselData: {clientRequestId, recommendedDestinations}
        } = this.props;

        if (isBoundingBoxSearch) {
            return <div />;
        }
        const data =
            recommendedDestinations.length >= 5 &&
            this.getPropertyWithImages(recommendedDestinations);

        const title = messages[LINGUA_TITLE_KEY.carousel_title];

        const popularPlaceTitle = intl.formatMessage(
            {
                id: 'popularPlaceTitle',
                defaultMessage: title
            },
            {
                placeName: name
            }
        );

        return (
            data &&
            data.length >= 5 && (
                <RecommendedDestinationsCarousel
                    breakpoints={BREAKPOINTS}
                    clientRequestId={clientRequestId}
                    customCardClickHandler={this.handleOnClick}
                    data={recommendedDestinations}
                    isLoading={isLoading}
                    scrolling
                    propertyViewEventFirePosition="onload"
                    title={popularPlaceTitle}
                    target={SERP_LARGE_SEARCH_TERM_DESTINATION}
                />
            )
        );
    }
}

const mapStateToProps = (state: ReduxState): StateProps => {
    const {searchParams} = state;
    const isBoundingBoxSearch = searchParams.isBoundingBoxSearch;

    return {
        isBoundingBoxSearch
    };
};

const mapDispatchToProps = {
    locationSearch: routerActions.locationSearch
};

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps),
    withLingua({
        namespace: 'discovery/xplorer',
        category: 'messages'
    })
)(DestinationCarousel);
